export default function InternalLink({ link, children, className }) {   
    const onPress = () => {  
        window.location.href = link;
    };

    return (
        <button 
            onClick={onPress}
            className={className}
        >
            {children}
        </button>
    );
}